import { render, staticRenderFns } from "./UserNotification.vue?vue&type=template&id=42c849a0&"
import script from "./UserNotification.vue?vue&type=script&lang=js&"
export * from "./UserNotification.vue?vue&type=script&lang=js&"
import style0 from "./UserNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports